import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Button, Input, Typography } from '@material-ui/core';
import { auth } from "./base";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    borderRadius: '25px',
    background: 'linear-gradient(63deg, rgba(77,190,223,1) 0%, rgba(14,42,81,1) 100%)',
    color: '#ffffff',
    width: '200px'
  },
  stripe: {
    height: 50
  },
  stripeBox: {
   backgroundColor: '#DCDCDC',
   borderRadius: '15px'
  },
  comp: {
   height: '200px'
   },
   textBox: {
     width: '400px'
   }
}));
function Finish() {
    const classes = useStyles();
    return (
        <div>
            <br/>
            <center>
                <img src="end.gif" className={classes.comp}/>
           
            <br/>
            <Typography variant='body1'>
                You have successfully setup the marketplace features on your aurafare account. Next, setup your custom aurafare account.
            </Typography>
            <br/>
            <Typography variant='h6'>
               Thank you!
            </Typography>
            <br/>
            <Button variant='contained' className={classes.submit} onClick={() => auth.signOut()}>
                Finish
            </Button>
             </center>
        </div>
    )
}

export default Finish
